import BaseBatchView from "../BaseBatchView.vue";
import BaseBatchList from "../Pages/BaseBatchList.vue";
import BaseBatchUpload from "../Pages/BaseBatchUpload.vue";

const routes = [
  {
    path: 'carga-base',
    component: BaseBatchView,
    children: [
      {
        path: '',
        name: 'celulares-base-batch',
        roles: ['status_pago_carga_base'],
        component: BaseBatchList
      },
      {
        path: 'carga',
        name: 'celulares-base-batch-upload',
        roles: ['status_pago_carga_base_carga'],
        component: BaseBatchUpload
      },
    ]
  },
]

export default routes
